import { UnidadSunat } from '../unidadsunat/unidad-sunat';

export class UnidadMedida {
    n?:string;
    idunidad?:number;
    unidad?:string;
    equivale?:string;
    codigo?:string;
    usuario_id:any;
    
    constructor(){
        //this.unidadsunat = new UnidadSunat();
    }
}
